module.exports = __webpack_public_path__ + "media/top/bubble_4-55fe21c5.svg";